module.exports = __webpack_public_path__ + "static/img/car_4_2_box@3x.f0798dbe.png";